export enum RowAction {
    EDIT = 'edit',
    DELETE = 'delete',
    DETAILS = 'details',
    DETAILS_ON_MODAL = 'details-on-modal',
    COPY = 'copy',
  }